<template>
    <el-scrollbar style="height:100%">
        <ul v-if="companyList.length > 0" class="company-list-container">
            <li
                @click="handleCompanyItem(item, index)"
                :class="[
                    'company-list-item',
                    { 'is-active': select === index }
                ]"
                v-for="(item, index) in companyList"
                :key="index"
            >
                <span class="company-list-left">{{ item.doc_name }}</span>
                <i class="iconfont icon-triangle-right"></i>
            </li>
        </ul>
        <div v-else class="company-list-container">
            <div class="no-data">
                <img src="@/assets/image/common/nodata.png" alt />
                <span>暂无数据</span>
            </div>
        </div>
    </el-scrollbar>
</template>
<script>
export default {
    props: {
        companyList: {
            type: Array
        }
    },
    data() {
        return {
            select: 0
        };
    },
    watch: {
        companyList: {
            handler(newValue) {
                this.companyList = newValue;
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        /**
         * 点击公司
         * params select {object}  选择的公司对象
         * params selectIndex {number}  index
         */
        handleCompanyItem(select, selectIndex) {
            this.select = selectIndex;
            this.$emit("handleCompanyItem", select);
        }
    }
};
</script>
<style lang="scss">
.company-list-container {
    // width: 255px;
    height: 100%;
    .no-data {
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
            width: px2Rem(150px);
            height: px2Rem(98px);
            margin-bottom: px2Rem(20px);
            margin-top: px2Rem(50px);
        }
    }
    .company-list-item {
        width: 100%;
        height: px2Rem(30px);
        line-height: px2Rem(30px);
        border-radius: 4px;
        margin-bottom: 4px;
        display: flex;
        flex-direction: row;
        padding-left: px2Rem(18px);
        padding-right: px2Rem(12px);
        background: transparent;
        font-size: px2Rem(14px);
        color: #fff;
        border: px2Rem(1px) solid #56fcff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        box-sizing: border-box;
        cursor: pointer;
        span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        i {
            font-size: px2Rem(12px);
        }
    }
    .is-active {
        background: #002d66;
        color: white;
    }
}
</style>
